import { useId } from "react";

function joinClassNames(...values) {
  return values.filter(Boolean).join(" ");
}

export default function EmptyState({
  icon,
  title,
  body,
  action,
  titleAs: Title = "h2",
  className = "",
  ...props
}) {
  const generatedId = useId().replace(/:/g, "");
  const titleId = `lz-v2-empty-state-title-${generatedId}`;
  const bodyId = body ? `lz-v2-empty-state-body-${generatedId}` : undefined;

  return (
    <section
      {...props}
      className={joinClassNames("lz-v2-empty-state", className)}
      aria-labelledby={titleId}
      aria-describedby={bodyId}
    >
      {icon ? <div className="lz-v2-empty-state__icon">{icon}</div> : null}
      <Title className="lz-v2-empty-state__title" id={titleId}>{title}</Title>
      {body ? <p className="lz-v2-empty-state__body" id={bodyId}>{body}</p> : null}
      {action ? <div className="lz-v2-empty-state__action">{action}</div> : null}
    </section>
  );
}
